import React from "react";
import { Link } from "react-router-dom";
import "../Styles/Footer.css";

function Footer() {
  return (  
    <div className="Footer">
      <div className="links">
        <Link to="/Privacy"> Privacy Policy </Link>
        <Link to="/Terms"> Terms of Service </Link>
        <Link to="/Contact"> Contact Us</Link>
      </div>
      <div className="statement">
        <p>
          <span className="bold">BeRealTimelapse</span> is an independent tool that creates timelapse videos from data associated with the BeReal app. It is not affiliated with BeReal or Voodoo.</p>
      </div>
    </div>
  );
}

export default Footer